import React from "react";
import { useEffect } from "react";
import { BsCalendar3 } from "react-icons/bs";
import { ImLink } from "react-icons/im";
import { MdLocationOn } from "react-icons/md";
import getDate from "../../utils/getDate";
import Avatar from "../avatar/Avatar";
import EditBtn from "../button/EditBtn";
import FollowBtn from "../button/FollowBtn";
import LogoutBtn from "../button/LogoutBtn";
import { MessageBtn } from "../button/MessageBtn";
import { useTranslation } from "react-i18next";
import "./UserCard.css";
import { useDispatch, useSelector } from "react-redux";
import { suspendVisitedProfile } from "../../redux/actions/visitedProfileActions";
import { IonButton } from "@ionic/react";

export const mutualFollows = (followers, following) => {
  const followerIds = new Set(followers.map((user) => user._id));
  return following.filter((user) => followerIds.has(user._id));
};

function ProfileCard({ profile, currentProfile }) {
  const { t } = useTranslation();
  const {
    username,
    avatar,
    banner,
    followers,
    following,
    createdAt,
    city,
    province,
  } = profile;
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentProfile.data);

  const mutualFollowsLength = mutualFollows(followers, following).length;

  return (
    <div className="profile-card">
      <div className="profile-card__banner">
        <img src={banner} alt="banner" />
      </div>
      {profile.suspended && (
        <div
          style={{
            backgroundColor: "#ff4d4f",
            color: "white",
            textAlign: "center",
            padding: "10px",
            fontWeight: "bold",
          }}
        >
          This account has been suspended
        </div>
      )}
      <div className="profile-card__bio">
        <div className=" display-flex align-items-c justify-content-sb">
          <div className="profile-card__bio--img display-flex justify-content-c align-items-c">
            <Avatar
              size="lg"
              username={username}
              avatar={avatar}
              province={province}
              isProfilePage={true}
              isFounder={profile.isFounder}
              latestAvatarPostId={profile.latestAvatarPostId}
              isOfficial={profile.isAdmin}
            />
          </div>
          {currentProfile ? (
            <div className="display-flex">
              <EditBtn />
              <LogoutBtn />
            </div>
          ) : profile.hasBlocked || profile.isBlockedBy ? (
            // Hide action buttons
            <div className="user-actions display-flex align-items-c profile-action-margin"></div>
          ) : (
            <div className="user-actions display-flex align-items-c profile-action-margin">
              <MessageBtn userId={profile._id} />
              <FollowBtn user={profile} />
            </div>
          )}
        </div>
        <h3>
          {profile.fname} {profile.lname}
        </h3>
        <small>@{profile.username}</small>
        <p className="word-wrap">{profile.bio}</p>

        <ul
          className=""
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            paddingLeft: "0",
            marginTop: "8px",
            marginBottom: "8px",
          }}
        >
          <li className="display-flex align-items-c">
            <MdLocationOn /> {[city, province].filter(Boolean).join(", ")}
          </li>
          <li className="display-flex align-items-c">
            <ImLink />
            <a href={profile.website}>{profile.website}</a>
          </li>
          <li className="display-flex align-items-c">
            <BsCalendar3 /> {t("joined")} {getDate(createdAt)}
          </li>
        </ul>
        <div className="profile-card__bio--follow display-flex">
          <p>
            <span>{following.length}</span> {t("following")}
          </p>
          <p>
            <span>{followers.length}</span> {t("followers")}
          </p>
          <p>
            <span>{mutualFollowsLength}</span> {t("friends")}
          </p>
        </div>
        {currentUser?.isAdmin && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <IonButton
              color={profile.suspended ? "success" : "danger"}
              shape="round"
              onClick={() => dispatch(suspendVisitedProfile(username))}
            >
              {profile.suspended ? "Unsuspend" : "Suspend"}
            </IonButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileCard;

